type AllowedFieldTypes = string | number;

export function convertFieldsToStrings(obj: Record<string, AllowedFieldTypes>): Record<string, string> {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, typeof value === 'number' ? String(value) : value]),
  );
}
